class EnhancedHTMLElement extends HTMLElement {
  log(...args) {
    console.log(`[${this.constructor.name}]`, ...args)
  }

  warn(...args) {
    console.warn(`[${this.constructor.name}]`, ...args)
  }

  onElementMutation(element, callback) {
    const observer = new MutationObserver(callback)
    observer.observe(element, { childList: true, subtree: true })

    return observer
  }
}

class FluidBeforeText extends EnhancedHTMLElement {
  constructor() {
    super()

    this.container = this.querySelector(this.props.childSelector)
    this.stylesheet = createStylesheet('')

    this.stylesheet.append()

    window.addEventListener(
      'resize',
      debounce(() => {
        this.resize()
      }, 100)
    )
  }

  get props() {
    return {
      screenWidthPercentage: parseFloat(this.getAttribute('data-screen-width-percentage')),
      childSelector: this.getAttribute('data-child-selector'),
      minFontSize: parseInt(this.getAttribute('data-min-font-size')),
    }
  }

  cleanup() {
    this.stylesheet.update('')
    this.querySelector(this.props.childSelector).style.removeProperty('--variable-font-size')
  }

  resize() {
    const container = this.querySelector(this.props.childSelector)

    if (!container) return

    this.cleanup()

    const style = window.getComputedStyle(container, ':before')
    const content = style.getPropertyValue('content')

    if (content === 'none') {
      throw new Error('No content found in :before pseudo-element')
    }

    const maxSize = window.innerWidth * this.props.screenWidthPercentage
    const currentFontSize = Math.max(parseInt(style.getPropertyValue('font-size')), this.props.minFontSize)

    this.stylesheet.update(`${this.props.childSelector}:before { font-size: var(--variable-font-size)!important; }`)
    container.style.setProperty('--variable-font-size', currentFontSize + 'px')

    while (parseInt(style.getPropertyValue('width')) >= maxSize) {
      container.style.setProperty(
        '--variable-font-size',
        parseInt(container.style.getPropertyValue('--variable-font-size')) - 5 + 'px'
      )
    }

    this.log('Resized')
  }

  connectedCallback() {
    this.resize()
  }
}

customElements.define('fluid-before-text', FluidBeforeText)

function createStylesheet(css) {
  const style = document.createElement('style')
  style.setAttribute('type', 'text/css')
  style.appendChild(document.createTextNode(css))

  return {
    append() {
      document.head.appendChild(style)
    },
    update(css) {
      style.textContent = css
    },
  }
}

function debounce(func, wait, immediate) {
  let timeout

  return function () {
    const context = this
    const args = arguments

    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }

    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}
